module.exports = __webpack_public_path__ + "static/media/corpoMulher2.2625ff9d.png";